var TextWithForm = function(){

    'use strict';

    var $ = jQuery;
    var instances = [];


    function onReady() {
        $('.module.textwithform').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 

        var $view = view,
            id = $view.data('id'),
            newsletterForm = false;

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * 

        function checkNewsletterRegisterForm() {
            if ($view.hasClass('newsletter-register-form')) {
                newsletterForm = true;
            }
        }

        function checkTransform() {
            if (newsletterForm === true) {
                var $closeButton = $('<a href="#close"></a>').addClass('btn btn-close');
                var $icon = $('<i></i>').addClass('icon icon-05-icon-fomento');
                $closeButton.append($icon);
                $view.append($closeButton);
                $closeButton.off().on('click', function(e) {
                    e.preventDefault();
                    $('a[href="#newsletter-register-form"]').removeClass('opened')
                    $('.textwithform.newsletter-register-form').animate({
                        height: 0
                    }, 500, function () {

                    });
                });
                $('a[href="#newsletter-register-form"]').off().on('click', function (e) {
                    e.preventDefault();
                    if ($(this).hasClass('opened')) {
                        $closeButton.trigger('click');
                        return;
                    }

                    var newHeight = jQuery('.newsletter-register-form.module.textwithform').children().first().outerHeight() + jQuery('.newsletter-register-form.module.textwithform').children().first().children().first().outerHeight();
                    $('.textwithform.newsletter-register-form').animate({
                        height: newHeight
                    }, 500, function () {

                    });
                    $('a[href="#newsletter-register-form"]').addClass('opened');
                });
            }
            else { // Formulario regular

            }
        }

        // instance object
        var instance = {
            init: function () {
                checkNewsletterRegisterForm();
                checkTransform();
            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

TextWithForm();
